import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.css'

export default function ProfileHeader({className, children}) {
  return <header className={`${className} ${styles.root}`}>{children}</header>
}

ProfileHeader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
}
